// Piezas compartidas por las pantallas de Tienda online — ADR-2026-10-06-metricas-de-tienda-online.
import { useUserGroup } from '../../../hooks/useUserGroup';
import type { Periodo } from './tipos';

/**
 * Las métricas de Tienda online son SÓLO para empresas con `dev_tester` (en cualquier
 * entorno): el resto de los usuarios ve Tienda online con sus lanzamientos y nada de
 * métricas (ADR-2026-10-07-metricas-solo-para-dev-testers). Mientras no se sabe —primer
 * login sin caché— es `false`: no se muestra y después aparece, nunca al revés. El
 * backend rechaza el endpoint a quien no es tester, así que esto es la UI, no el candado.
 */
export function useMetricasVisibles(): boolean {
  return useUserGroup().isDevTester === true;
}

const PERIODOS: Periodo[] = [7, 30, 90];

/** 7, 30 o 90 días. Un control segmentado: es una cosa o la otra y se ve cuál está puesta. */
export function SelectorDePeriodo({ valor, onCambiar }: { valor: Periodo; onCambiar: (p: Periodo) => void }) {
  return (
    <div role="radiogroup" aria-label="Período" className="inline-flex rounded-xl bg-neutral-100 p-1">
      {PERIODOS.map((p) => (
        <button
          key={p}
          type="button"
          role="radio"
          aria-checked={valor === p}
          onClick={() => onCambiar(p)}
          className={`rounded-lg py-1.5 px-3 text-xs font-medium transition-colors ${
            valor === p ? 'bg-white text-brand-black shadow-sm' : 'text-neutral-500 hover:text-brand-black'
          }`}
        >
          {p} días
        </button>
      ))}
    </div>
  );
}
